(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Iso_country_codes', Iso_country_codes);

    Iso_country_codes.$inject = ['$resource'];

    function Iso_country_codes ($resource) {
        var resourceUrl =  'api/iso-country-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
